/**
 * @generated SignedSource<<54a52d2c14714d4810f5479431090f90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SchoolExamSourceResetInput = {
  id: string;
};
export type SchoolExamSourceId_schoolExamSourceResetMutation$variables = {
  input: SchoolExamSourceResetInput;
};
export type SchoolExamSourceId_schoolExamSourceResetMutation$data = {
  readonly schoolExamSourceReset: {
    readonly id: string;
  };
};
export type SchoolExamSourceId_schoolExamSourceResetMutation = {
  response: SchoolExamSourceId_schoolExamSourceResetMutation$data;
  variables: SchoolExamSourceId_schoolExamSourceResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SchoolExamSource",
    "kind": "LinkedField",
    "name": "schoolExamSourceReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolExamSourceId_schoolExamSourceResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SchoolExamSourceId_schoolExamSourceResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b6f88ad740ffcc3b8ccc916a87c9c2a9",
    "id": null,
    "metadata": {},
    "name": "SchoolExamSourceId_schoolExamSourceResetMutation",
    "operationKind": "mutation",
    "text": "mutation SchoolExamSourceId_schoolExamSourceResetMutation(\n  $input: SchoolExamSourceResetInput!\n) {\n  schoolExamSourceReset(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1cb64d9e274d36eff6b83862a581653";

export default node;
